// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3P5eF","imageUploader":"EGiftCard_imageUploader__2Vya8"};